import classNames from 'classnames';
import kebabCase from 'lodash/kebabCase';
import React from 'react';

const SentimentDot = ({ outline, sentiment, small, reverse }) => (
  <span
    className={classNames('sentiment-dot', {
      'sentiment-dot-outline': outline,
      'sentiment-dot-sm': small,
      [`sentiment-dot-${kebabCase(reverse ? `-${sentiment}-reverse` : sentiment)}`]:
        sentiment,
    })}
  />
);

SentimentDot.defaultProps = {
  outline: false,
  small: false,
};

export default SentimentDot;
